export default window._cmsContent['solar/when-at-home']